export const CONSENT_KEY = 'game_hub_consent_v1';
export const CONSENT_EVENT = 'game-hub:consent';

export function readConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed.analytics !== 'boolean') return null;
    return { necessary: true, analytics: parsed.analytics };
  } catch {
    return null;
  }
}

export function writeConsent(consent) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
}

export function hasAnalyticsConsent() {
  return readConsent()?.analytics === true;
}
